import {
  MDSGridListItem,
  MDSGridListItemProps,
  MDSGridListItemSlotName,
} from "@/mds/components/lists/grid-list-item";
import { StyledHeader, StyledGridList, StyledLeftAddon, StyledRightAddon } from "./grid-list.style";
import { MDSGridListProps } from "./grid-list.types";

export const MDSGridList = ({ items, label, children, ...props }: MDSGridListProps) => {
  if (!items && children) {
    // static grid list
    return (
      <>
        {label && <StyledHeader>{label}</StyledHeader>}
        <StyledGridList {...props} aria-label={label}>
          {children}
        </StyledGridList>
      </>
    );
  }

  // dynamic grid list
  return (
    <>
      {label && <StyledHeader>{label}</StyledHeader>}
      <StyledGridList {...props} items={items} aria-label={label}>
        {(item: MDSGridListItemProps) => (
          <MDSGridListItem {...item}>
            {item.leftAddon && (
              <StyledLeftAddon slot={MDSGridListItemSlotName.LeftAddon}>
                {item.leftAddon}
              </StyledLeftAddon>
            )}
            {item.children}
            {item.rightAddon && (
              <StyledRightAddon slot={MDSGridListItemSlotName.RightAddon}>
                {item.rightAddon}
              </StyledRightAddon>
            )}
          </MDSGridListItem>
        )}
      </StyledGridList>
    </>
  );
};
